export const slack_channels = state => state.slack.channels
export const slack_get_profile = state => state.slack.profile
export const slack_is_signed_in = state => state.slack.is_signed_in
export const slack_users = state => state.slack.users
export const slack_users_object = state => state.slack.users_object
